import React from "react";
import "./style.scss";
import EventHandler from "../EventHandler";

type OptionProps = {
  title: string;
  value: string;
  disabled?: boolean;
};

type IProps = {
  options: OptionProps[];
  onClick?: any;
};

const MoreOptions = ({ options, onClick, ...props }: IProps) => {
  return (
    <div className="more-dropdown-container" tabIndex={-1}>
      <div className="three-dots"></div>
      <div className={options?.length == 3 ? "dropdownLength" : "dropdown"}>
        {(Array.isArray(options) && options.length) ?
          options?.map((item: OptionProps, idx: number) => (
            <div
              key={item.value + idx}
              className={`option-container${item.disabled ? ' option-disabled' : ''}`}
              onClick={item.disabled ? undefined : (e: any) => {
                onClick(e, item, props);
              }}
              tabIndex={item.disabled ? -1 : 0}
              aria-disabled={item.disabled}
            >
              <span className="option-title">{item.title}</span>
            </div>
          )) : null}
      </div>
    </div>
  );
};

export default MoreOptions;
